<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Liste des clients</h1>
                <div class="pageOptions">
                    <Btn text="Ajouter" ico="add" @click="add" v-if="$store.getters.hasPerm('customer:add/edit')"></Btn>
                </div>
            </div>
            <search-bar @search="search" :value="filter"></search-bar>
        </div>
        <div class="table-responsive">
            <table>
                <thead>
                <tr>
                    <th>
                        N°
                        <table-order name="id" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Societe
                        <table-order name="company" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Ville
                        <table-order name="city" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Téléphone
                        <table-order name="phone" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Mail
                        <table-order name="mail" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Gerant
                        <table-order name="company_role" @change="changeOrder"></table-order>
                    </th>
                    <th>Options</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(customer, key) in visibles">
                    <td>{{customer.id}}</td>
                    <td>{{customer.company}}</td>
                    <td>{{customer.city}}</td>
                    <td>{{customer.phone}}</td>
                    <td>{{customer.mail}}</td>
                    <td>{{customer.company_role}}</td>
                    <td class="tableOptions">
                        <div v-if="$store.getters.hasPerm('questionnaire:list')" @click="questionnaire(customer.id)" title="Afficher les questionnaires du client" >
                            <svg class="option">
                                <use xlink:href="#icon-survey"></use>
                            </svg>
                        </div>
                        <div @click="edit(customer.id)" v-if="$store.getters.hasPerm('customer:add/edit')" title="Modifier le client">
                            <svg class="option" >
                                <use xlink:href="#icon-edit"></use>
                            </svg>
                        </div>
                        <div @click="del(customer)" v-if="$store.getters.hasPerm('customer:del')" title="Supprimer le client">
                            <svg class="option">
                                <use xlink:href="#icon-delete"></use>
                            </svg>
                        </div>
                    </td>
                </tr>
                <tr v-if="visibles.length <= 0">
                    <td colspan="7" style="text-align: center">Il n'y a aucun client</td>
                </tr>
                </tbody>
            </table>
        </div>
        <pagination :current="currentPage" :limit="limit" :array="filters" @change="pageChange" @limitChange="limitChange"></pagination>
    </div>
</template>

<script>

    import SearchBar from "@/components/SearchBar";
    import Btn from "@/components/Btn";
    import Loader from "@/components/Loader";
    import axios from 'axios';
    import tools from '../config.ts';
    import Pagination from "@/components/Pagination";
    import TableOrder from "@/components/TableOrder";

    export default {
        name: "Customers",
        components: {TableOrder, Pagination, Btn, SearchBar, Loader},
        data() {
            return {
                customers: [],

                currentPage: 0,
                limit: 100,
                filter: "",
                order : {
                    order:'asc',
                    name:'company',
                },

                locals: ["customers", "currentPage", "filter","order"],
                cookies: ["limit"],
            }
        },
        methods: {
            load() {

                tools.loader(true);
                axios.get(tools.api("customers"), tools.headerGET())
                    .then((response) => {
                        this.customers = response.data;

                        tools.loader(false);
                        tools.saveLocals("customers", this);
                    })
                    .catch((e) => {
                        tools.loader(false);
                    })
            },
            add() {
                this.$router.push("customer")
            },
            edit(customer_id) {
                this.$router.push("customer/" + customer_id)
            },
            questionnaire(customer_id) {
                this.$router.push("customer/" + customer_id+ "/questionnaires")
            },
            del(customer) {
                tools.popup("confirm", {
                    message: "Voulez vous vraiment supprimer le client '" + customer.company + "' ?",
                    success: () => {
                        axios.delete(tools.api("customer/" + customer.id), tools.headerPOST())
                            .then((response) => {
                                if (!tools.isSuccessResponse(response)) {
                                    return tools.popup("valid", {
                                        title: "Erreur",
                                        message: "Erreur lors de la suppression du client.",
                                    });
                                }

                                this.load();
                            })
                            .catch((error) => {
                                tools.popup("valid", {
                                    title: "Erreur",
                                    message: "Erreur lors de la suppression du client. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                                })
                            })
                    }
                })
            },
            search(filter) {
                this.filter = filter;
                tools.saveLocals("customers", this);
            },
            limitChange(limit) {
                this.limit = limit;
                this.currentPage = 0;

                tools.saveCookies("customers", this);
            },
            pageChange(page) {
                this.currentPage = page;
                tools.saveLocals("customers", this);
            },
            changeOrder(data) {
                this.order = {
                    order: data.order,
                    name: data.name
                }
                tools.saveLocals("customers", this);
            }
        },
        computed: {
            filters() {

                let customers = this.customers;

                if (this.filter) {
                    console.log(this.filter)
                    let reg = new RegExp(this.filter, "i");
                    customers = customers.filter((customer) => reg.exec(customer.company) || reg.exec(customer.address_1) || reg.exec(customer.city) || reg.exec(customer.phone) || reg.exec(customer.mail) || reg.exec(customer.postal_code) || reg.exec(customer.id))
                }

                tools.sortArray(customers,this.order)

                return customers;
            },
            visibles() {
                return this.filters.slice(this.currentPage * this.limit, (this.currentPage * this.limit) + parseInt(this.limit));
            }
        },
        mounted() {

            if (!this.$store.getters.hasPerm('customer:list')) {
                return this.$router.back();
            }

            tools.setLocals("customers", this);
            tools.setCookies("customers", this);

            tools.$emit("orderChange",this.order);

            this.$store.commit("onEditMode", false);

            this.load()
        }
    }
</script>

<style scoped>

</style>